import SeeAllNotificationsView from "./SeeAllNotificationsView";

export default SeeAllNotificationsView;
